import { inject, Inject, Injectable } from '@angular/core';
import { Store } from '@sama/app-state';
import { shapeTypeToToolName } from '../../../cross-team-shared/annotation/shared/abstract-tool';
import { ToolName } from '../../../cross-team-shared/tools-names';
import { IN_PROGRESS_INDEX } from '../../../team-apis/core/reserved-shape-indexes';
import { ShapeType } from '../../../team-apis/otterdam/answers/shape-typings';
import { AnnotationOutput } from '../../../team-apis/otterdam/outputs/annotation-output';
import { OutputInfo, outputInfoStoreToken } from '../../h3ml/state/output-info';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';

function injectShapesStore() {
  const taskWorkspaceStore = inject(TaskWorkspaceStore);
  const outputInfoStore = inject(outputInfoStoreToken);
  return taskWorkspaceStore('outputAnnotationInfo')(
    outputInfoStore.state().output.name,
    // @ts-ignore -- fix me
  )('shapes');
}

@Injectable()
export class ShapeAccessService {
  // for some obscure reason, it's impossible to inject shapeInfoStoreToken
  private readonly shapesStore = injectShapesStore();
  private readonly taskWorkspaceStore = inject(TaskWorkspaceStore);

  private output: AnnotationOutput;

  constructor(
    @Inject(outputInfoStoreToken)
    outputInfoStore: Store<OutputInfo<AnnotationOutput>>,
  ) {
    this.output = outputInfoStore.state().output;
  }

  isShapeEditable(shapeIndex: number) {
    if (
      shapeIndex === IN_PROGRESS_INDEX ||
      this.taskWorkspaceStore.isUsingObjects()
    ) {
      return true;
    }
    const shape = this.shapesStore.state()[shapeIndex];
    // fix me if you change this code

    // @ts-ignore -- fix me
    return this.isShapeTypeEditable(shape.type);
  }

  isShapeTypeEditable(shapeType: ShapeType) {
    const toolName = shapeTypeToToolName(shapeType);
    const availableTools: ToolName[] = this.output.meta.available_tools;
    return availableTools.includes(toolName);
  }
}
